import moment from "moment";
import {
  OrderType,
} from "./foodPrepTimeConstants";

export function getStepperHeaderText(orderType) {
  const GHD_TEXT = "When will this be ready for a driver?";
  const SELF_DELIVERY_TEXT = "When will the food be delivered?";
  const PICKUP_TEXT = "When will the food be ready for pickup?";

  const textForOrderType = {
    [OrderType.GRUBHUB_DELIVERY]: GHD_TEXT,
    [OrderType.SELF_DELIVERY]: SELF_DELIVERY_TEXT,
    [OrderType.PICKUP]: PICKUP_TEXT,
  };
  return textForOrderType[orderType];
}

export function getStepperChangedMinsText({
  orderType,
  prepMins,
  initialPrepMins,
}) {
  const LESS_THAN_DEFAULT_GHD =
    "We may not be able to get a driver to you this quickly, but we will send a driver as soon as we can.";
  const GREATER_THAN_DEFAULT_PICKUP =
    "Customers see your default pickup time when placing an order. Changing the time for this order may result in a poor experience.";
  const GREATER_THAN_DEFAULT_SD_OR_GHD =
    "Changing the time for this order may result in a poor diner experience.";

  if (prepMins < initialPrepMins) {
    return orderType === OrderType.GRUBHUB_DELIVERY
      ? LESS_THAN_DEFAULT_GHD
      : null;
  } else if (prepMins > initialPrepMins) {
    return orderType === OrderType.PICKUP
      ? GREATER_THAN_DEFAULT_PICKUP
      : GREATER_THAN_DEFAULT_SD_OR_GHD;
  } else {
    return null;
  }
}

export function getStepperHaveReadyText(orderType) {
  const GRUBHUB_DELIVERY_TEXT = "Have food ready for driver by";
  const SELF_DELIVERY_TEXT = "Delivery by";
  const PICKUP_TEXT = "Ready for pickup by";

  const textForOrderType = {
    [OrderType.GRUBHUB_DELIVERY]: GRUBHUB_DELIVERY_TEXT,
    [OrderType.SELF_DELIVERY]: SELF_DELIVERY_TEXT,
    [OrderType.PICKUP]: PICKUP_TEXT,
  };
  return textForOrderType[orderType];
}

export function getStepperConfirmText(orderType, prepMins) {
  const endingTextForOrderType = {
    [OrderType.GRUBHUB_DELIVERY]: "minutes",
    [OrderType.SELF_DELIVERY]: "minute delivery time",
    [OrderType.PICKUP]: "minute prep time",
  };
  return `Confirm ${prepMins} ${endingTextForOrderType[orderType]}`;
}

export function getFormattedPrepTime(prepMins) {
  return moment().add(prepMins, "minutes").format("h:mma");
}


// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTimeHelpers.js